var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access"},[_c('BackBtn'),_c('v-icon',{staticClass:"my-8",attrs:{"color":"red","x-large":""}},[_vm._v("mdi-cancel")]),_c('h3',[_vm._v("Страница не найдена")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }